(ns frontend.view.entity-viewers.modules.counterparty-diligences.view
  (:require
   [frontend.view.entity :as f-entity]
   [ui.state.session.sub :as session-sub]
   [frontend.view.entity-viewers.modules.counterparty-diligences.sub :as sub]
   [frontend.view.entity-viewers.modules.counterparty-diligences.event :as event]
   [reagent.core :as r]
   [re-frame.core :as rf]
   [common.entity :as entity]
   [common.localization :as loc]
   [frontend.utils :as fu]
   [ui.util :as uu]
   [ui.components.modal.view :as modal]
   [ui.components.button.view :as button]
   [ui.editors.labelled-input.view :as labelled-input]
   [common.util :as cu]
   [common.schema.registry :as registry]
   [ui.view.counterparty-diligence.send-to-responders-modal.model :refer [default-email-subject
                                                                          default-email-body]]))

(defn create-and-send-to-responders-modal
  []
  (let [tenant @(rf/subscribe [::session-sub/tenant])
        tenant-schema @(rf/subscribe [::session-sub/tenant-schema])
        template-field-schema (registry/get-field-schema tenant-schema :project-counterparty-diligence/template)
        all-template-options (:options template-field-schema)
        option-filter-fn (:field/option-filter-fn template-field-schema)
        tenant-template-options (->> all-template-options
                                     (filterv (fn [option]
                                                (option-filter-fn
                                                 {:tenant tenant
                                                  :entity-candidate option}))))
        initial-state {:project-name ""
                       :fund-name ""
                       :e-signature-required :yes
                       :template (some-> tenant-template-options
                                         first
                                         :value)
                       :responders []
                       :email-subject (default-email-subject)
                       :email-body    (default-email-body)}
        state* (r/atom initial-state)
        modal-visible?* (r/atom true)]
    (fn [{:keys [entity]}]
      (let [{:keys [project-name fund-name template e-signature-required
                    responders email-subject email-body]} @state*
            data-filled? (and (not (cu/blank-value? project-name))
                              (not (cu/blank-value? fund-name))
                              (keyword? e-signature-required)
                              (keyword? template)
                              (seq responders)
                              (not (cu/blank-value? email-subject))
                              (not (cu/blank-value? email-body)))
            submitting? @(rf/subscribe [::sub/submitting? (:db/id entity)])
            can-submit? (and data-filled? (not submitting?))
            close-modal (fn []
                          (reset! state* initial-state)
                          (rf/dispatch [::event/close-create-modal (:db/id entity)]))
            submit! (fn []
                      (rf/dispatch [::event/create-project-diligence-and-send-to-responders
                                    {:entity-id (:db/id entity)
                                     :project-name project-name
                                     :fund-name fund-name
                                     :template template
                                     :e-signature-required e-signature-required
                                     :responders responders
                                     :email-subject email-subject
                                     :email-body email-body}]))]
        [modal/view
         {:visible? @modal-visible?*
          :hide! close-modal}
         [:div (loc/tr :create-project-counterparty-diligence)]
         [:div
          {:class "flex flex-col gap-8 font-normal"}
          [:div
           {:class "flex flex-col gap-4"}
           [:p
            {:class "font-semibold"}
            (loc/tr :diligence-details)]
           [labelled-input/view
            {:data-type :data.type/text-simple
             :value project-name
             :on-change #(swap! state* assoc :project-name %)
             :label (loc/tr :project-counterparty-diligence/project-name)}]

           [labelled-input/view
            {:data-type :data.type/text-simple
             :value fund-name
             :on-change #(swap! state* assoc :fund-name %)
             :label (loc/tr :project-counterparty-diligence/fund-name)}]

           (when-not (-> tenant-template-options
                         count
                         (= 1))
             [labelled-input/view
              {:label (loc/tr :project-counterparty-diligence/template)
               :data-type :data.type/keyword
               :value template
               :options tenant-template-options
               :on-change #(swap! state* assoc :template %)}])

           [labelled-input/view
            {:data-type :data.type/keyword
             :value e-signature-required
             :on-change #(swap! state* assoc :e-signature-required %)
             :label (loc/tr :counterparty-diligence/e-signature-required)
             :options [{:value :yes
                        :label (loc/tr :yes)}
                       {:value :no
                        :label (loc/tr :no)}]}]]

          [:div
           {:class "flex flex-col gap-4"}
           [:p
            {:class "font-semibold"}
            (loc/tr :invite-email-details)]
           [labelled-input/view
            {:editor-type :editor.type/search
             :label (loc/tr :counterparty-diligence/responder)
             :data-type :data.type/ref-multi
             :field/entity-types [:entity.type/account :entity.type/person]
             ;:placeholder (loc/tr :add-responder)
             :value responders
             :on-change (fn [_value options]
                          (swap! state* assoc :responders (vec options)))
             :create! (fn [initial-value]
                        (reset! modal-visible?* false)
                        (f-entity/open-creator!
                         :entity.type/person
                         {:start-value initial-value
                          :skip-success-msg? true
                          :creation-pipeline-id nil
                          :on-cancel! (fn []
                                        (reset! modal-visible?* true))
                          :on-close! (fn []
                                       (reset! modal-visible?* true))
                          :on-ok! (fn [{:keys [new-entity close-cb!] :as _args}]
                                    (let [new-opt {:value (:db/id new-entity)
                                                   :label (entity/display-string new-entity)}]
                                      (swap! state* update :responders (fnil conj []) new-opt)
                                      (reset! modal-visible?* true)
                                      (close-cb!)))}))}]

           [labelled-input/view
            {:data-type :data.type/text-simple
             :label (loc/tr :email-subject)
             :value email-subject
             :on-change #(swap! state* assoc :email-subject %)}]

           [labelled-input/view
            {:data-type :data.type/text-multiline
             :label (loc/tr :message)
             :value email-body
             :on-change #(swap! state* assoc :email-body %)}]]]
         [:<>
          [button/sm-secondary-hollow
           {:on-click close-modal}
           (loc/tr :cancel)]
          [button/sm-primary-solid
           {:disabled? (not can-submit?)
            :on-click submit!}
           (loc/tr :create-and-send-to-responders)]]]))))

(defn header-view
  [{:keys [entity]}]
  (let [create-modal-open? @(rf/subscribe [::sub/create-modal-open? (:db/id entity)])]
    [:div
     (when create-modal-open?
       [create-and-send-to-responders-modal
        {:entity entity}])
     [:button
      {:on-click #(rf/dispatch [::event/open-create-modal (:db/id entity)])}
      [:i.fal.fa-plus-circle.text-md]]]))

(defn status-display
  [{:keys [entity]}]
  (let [status (:counterparty-diligence/status entity)]
    [:div
     {:class "flex items-start gap-1"}
     [:i
      {:class (uu/cm "text-sm m-0 text-base-light-text-paler"
                     (case status
                       :counterparty-diligence.status/draft
                       "fal fa-file-text"
                       :counterparty-diligence.status/sent-to-responders
                       "fal fa-envelope"
                       :counterparty-diligence.status/waiting-for-e-sign
                       "fal fa-clock"
                       :counterparty-diligence.status/review
                       "fal fa-eye"
                       :counterparty-diligence.status/completed
                       "fal fa-check font-semibold"
                       "fal fa-question"))}]
     [:p
      {:class "text-sm m-0 text-base-light-text-paler"}
      (loc/tr (case status
                :counterparty-diligence.status/draft :draft
                :counterparty-diligence.status/sent-to-responders :sent-to-responders
                :counterparty-diligence.status/waiting-for-e-sign :waiting-for-e-signature
                :counterparty-diligence.status/review :under-review
                :counterparty-diligence.status/completed :completed
                :unknown))]]))

(defn counterparty-diligence-item
  [{:keys [entity] :as props}]
  (let [display-str (entity/display-string entity)]
    [:div
     {:class (uu/cm "border rounded px-3 py-2 flex items-center justify-between")}
     [:div
      {:class "flex gap-4 items-center"}
      [:p
       {:class "font-semibold m-0"}
       display-str]
      [status-display props]]

     [:div
      [:div
       {:class "mb-0 text-sm text-base-light-text-paler"}
       (fu/format-date-ts (:common/created-on entity) "." true)]]]))

(defn view
  [{:keys [entity]}]
  (r/create-class
   {:component-did-mount (fn []
                           (rf/dispatch [::event/get-counterparty-diligences-associated-with-entity (:db/id entity)]))
    :reagent-render
    (fn [{:keys [entity]}]
      (let [counterparty-diligences @(rf/subscribe [::sub/associated-counterparty-diligences (:db/id entity)])]
        [:div
         {:class "flex flex-col gap-3 pl-1.5 pt-2"}
         (->> counterparty-diligences
              (map (fn [entity]
                     ^{:key (-> entity :db/id str)}
                     [counterparty-diligence-item
                      {:entity entity}])))

         (when (empty? counterparty-diligences)
           [:p
            {:class "text-base-light-text-paler text-sm m-0"}
            (loc/tr :no-counterparty-diligences-create-cta)])]))}))
